import * as setup from '@/setup';
export default class Letter extends Phaser.GameObjects.Text {
	/**
   *  My custom dynamic bitmap text.
   *
   *  @constructor
   *  @class Letter
   *  @extends Phaser.GameObjects.Text
   *  @param {Phaser.Scene} scene - The scene that owns this bitmap text.
   *  @param {number} x - The horizontal coordinate relative to the scene viewport.
   *  @param {number} y - The vertical coordinate relative to the scene viewport.
   *  @param {string} text - The text to display.
   *  @param {object} style - The style applied to text.
   * 
   */
	constructor(scene, x, y, text, style) {
		super(scene, x, y, 'letter');
		let textStyle = setup.styles.colorLetterStyle;
		this.setText(text || 'Text');
		this.setX(x || 10);
		this.setY(y || 10);
		this.setStyle(textStyle || style);
		this.setShadow(1, 1, '#000000', 2, true, true);
		//  Add this game object to the owner scene.
		scene.children.add(this);
	}
}
